// extracted by mini-css-extract-plugin
export default {"ArchivePageTitle":"ArchivePageTitle_ArchivePageTitle__OTY1M"};